import { Stack, Text } from '@chakra-ui/layout'

import get from 'lodash/get'
import React from 'react'

import { cpf } from 'cpf-cnpj-validator'

type ModalBodyProps = {
  original: {}
}

type ModalBodyFieldProps = {
  title: string
  description: string
}

function ModalBodyField({ title, description }: ModalBodyFieldProps) {
  return (
    <Stack direction={{ base: 'column', tablet: 'row' }} alignItems="center">
      <Text fontSize="md" fontWeight="bold">
        {title}
      </Text>
      <Text fontSize="sm" fontWeight="normal">
        {description}
      </Text>
    </Stack>
  )
}

export function ModalBodyAccredited({ original }: ModalBodyProps) {
  const cpfFormated = React.useMemo(() => {
    const getCpf = get(original, 'cpf')

    return cpf.format(getCpf)
  }, [original])

  return (
    <>
      <ModalBodyField title="Name:" description={get(original, 'name')} />

      <ModalBodyField title="E-mail:" description={get(original, 'email')} />
      <ModalBodyField
        title="Vinculado a:"
        description={get(original, ['monthly', 'name'], '')}
      />
      <ModalBodyField title="CPF:" description={cpfFormated} />
      <ModalBodyField
        title="Celular:"
        description={get(original, 'phone')
          .replaceAll(' ', '')
          .replace(/(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3')}
      />
      <ModalBodyField
        title="Tipo de veículo:"
        description={get(original, 'vehicle_type')}
      />
      <ModalBodyField
        title="Placa:"
        description={get(original, 'vehicle_license_plate')}
      />
      <ModalBodyField
        title="Modelo:"
        description={get(original, 'vehicle_model')}
      />
      <ModalBodyField
        title="Cor:"
        description={get(original, 'vehicle_collor')}
      />
    </>
  )
}
